import { UserMinus } from "lucide-react";
import type { ListMemberRef } from "@guestbook/shared";
import { Button } from "@/shared/components/ui/Button";
import { useRemoveListMembers } from "@/shared/lib/lists";

interface RemoveSelectedButtonProps {
  listId: string;
  selectedIds: string[];
  onDone: () => void;
}

/**
 * Bulk "remove from list" action — used only when the contacts page is
 * scoped to a list. Non-destructive: contacts remain, only the list
 * membership rows are deleted (DELETE /lists/:id/members).
 */
export function RemoveSelectedButton({
  listId,
  selectedIds,
  onDone,
}: RemoveSelectedButtonProps) {
  const remove = useRemoveListMembers(listId);
  function handleClick() {
    const members: ListMemberRef[] = selectedIds.map((id) => ({ contactId: id }));
    remove.mutate({ members }, { onSuccess: () => onDone() });
  }
  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={handleClick}
      disabled={selectedIds.length === 0 || remove.isPending}
      aria-label="Remove from list"
    >
      <UserMinus aria-hidden className="h-4 w-4" />
      <span className="hidden sm:inline">
        {remove.isPending ? "Removing…" : "Remove"}
      </span>
    </Button>
  );
}
